




















import { Component, Mixins } from 'vue-property-decorator'
import { Playlist } from '@/classes/playlist'
import { LibraryMixin } from '@/mixins'
import { normalizeTitle } from '@/helpers/track'
import * as _ from 'lodash'

@Component({
  components: {
    PlaylistSelector: require('@/components/PlaylistSelector').default,
    Controls: require('../Controls').default,
    ProgressLoader: require('@/components/ProgressLoader').default
  }
})
export default class DiscoveryPlaylist extends Mixins(LibraryMixin) {
  selectedPlaylists: Playlist[] = []
  loading: boolean = false

  get disabled(): boolean {
    return this.selectedPlaylists.length === 0 || this.selectedPlaylists[0].tracks.length === 0
  }

  async start() {
    const trackIds: string[] = _.sampleSize(this.selectedPlaylists[0].tracks, 100)

    const normalized: {
      artist: string
      title: string
    }[] = []

    for (const trackId of trackIds) {
      const track = this.library.tracksObject[trackId]

      if (track) {
        normalized.push({
          artist: track.artist,
          title: normalizeTitle(track.title)
        })
      }
    }

    this.$store.commit('discovery/setNormalizedTracks', normalized)
  }
}
